import { useLayoutConstants } from "@BehpardazBarin/frontend_components";
import { useLocation } from "react-router";

export const useBackButtonSX = () => {
  const { pathname } = useLocation();
  const { isMobile } = useLayoutConstants(pathname);
  const backButtonSX = !isMobile
    ? {
        position: "absolute",
        top: "11.85%",
        left: "13.89%",
      }
    : { position: "absolute", top: 28, left: 28 };
  return backButtonSX;
};
